var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"percentage-container"},[_c('div',{staticClass:"percentage-bar",style:(("width: " + _vm.percentage + "%; backgroundColor: " + _vm.color))})])}
var staticRenderFns = []

export { render, staticRenderFns }